import React, { useState } from 'react'
import { Container, Typography, Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Markdown from 'marked-react';
import { Localized } from '@fluent/react';

const faqData = [
  {
    question: 'faq_why_choose_question',
    answer: 'faq_why_choose_answer',
    button: 'faq_why_choose_button',
    cb: 'cbwhychoose'
  },
  {
    question: 'faq_how_to_get_question',
    answer: 'faq_how_to_get_answer',
    button: 'faq_how_to_get_button',
    cb: 'cbgetcard'
  },
  {
    question: 'faq_how_to_top_up_question',
    answer: 'faq_how_to_top_up_answer',
    button: 'faq_how_to_top_up_button',
    cb: 'cbtopup'
  },
  {
    question: 'faq_recurring_payments_question',
    answer: 'faq_recurring_payments_answer',
    button: 'faq_recurring_payments_button',
    cb: 'cbrecurringpayments'
  },
  {
    question: 'faq_cards_number_question',
    answer: 'faq_cards_number_answer',
    button: 'faq_cards_number_button',
    cb: 'cbcardsnumber'
  },
  {
    question: 'faq_wallets_question',
    answer: 'faq_wallets_answer',
    button: 'faq_wallets_button',
    cb: 'cbwallets'
  },
  {
    question: 'faq_paypal_question',
    answer: 'faq_paypal_answer',
    button: 'faq_paypal_button',
    cb: 'cbpaypal'
  },
  {
    question: 'faq_safety_question',
    answer: 'faq_safety_answer',
    button: 'faq_safety_button',
    cb: 'cbsafety'
  },
  {
    question: 'faq_kyc_question',
    answer: 'faq_kyc_answer',
    button: 'faq_kyc_button',
    cb: 'cbkyc'
  },
  {
    question: 'faq_aml_question',
    answer: 'faq_aml_answer',
    button: 'faq_aml_button',
    cb: 'cbaml'
  }
];

export function FAQ() {
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const items = faqData.map((item) => (
    <ItemFAQ key={item.cb} expanded={expanded} handleChange={handleChange} item={item} />
  ));

  return (
    <>
      <Container sx={{
        mb: '4vh',
        flexGrow: 1,
      }}>
        <Typography variant="h3">
          <Localized id={'faq'} />
        </Typography>
      </Container>
      {items}
    </>
  )
}

function ItemFAQ(props) {
  const { expanded, handleChange, item } = props;
  const { question, answer, cb } = item;

  return (
    <Accordion
      sx={{ backgroundColor: '#00000000' }}
      expanded={expanded === cb}
      onChange={handleChange(cb)}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`${cb}-content`}
        id={`${cb}-header`}
      >
        <Typography fontWeight={'bold'} sx={{ textAlign: 'left' }}>
          <Localized id={question}>
            {question}
          </Localized>
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography sx={{ textAlign: 'left' }} className={'faqmd'}>
          <Localized id={answer}>
            <Markdown>
              {answer}
            </Markdown>
          </Localized>
        </Typography>
      </AccordionDetails>
    </Accordion>
  )
}

export default FAQ